//libs
import React from "react";

//helper
import cx from "classnames";

//styles
import S from "./style.module.scss";

//constants
import { STRINGS, WARNINGS } from "src/shared/constants";

//components
import { Form, Formik } from "formik";
import {
  CustomButton,
  CustomTextArea,
} from "src/components";

export const SendMailForm = ({ onSubmit = () => {}, formData = {} }) => {
  const hanldeFormSubmit = (values, { resetForm }) => {
    onSubmit(values, () => {
      resetForm();
    });
  };

  return (
    <Formik
      validate={validate}
      enableReinitialize
      initialValues={{
        body: formData?.body || "",
      }}
      onSubmit={hanldeFormSubmit}
    >
      {({
        handleChange,
        handleSubmit,
        handleBlur,
        resetForm,
        errors,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit} className={S.form}>
          <div className={S.formBody}>
            <div className={S.formBodyTextArea}>
              <CustomTextArea
                label={STRINGS.NOTIFICATION_MESSAGE}
                name={STRINGS.EMAIL_BODY}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                containerClass={S.formBodyTextAreaContainer}
                labelClass={S.formBodyLabel}
                inputClass={S.formBodyTextAreaInput}
                value={values[STRINGS.EMAIL_BODY]}
                handleBlur={handleBlur}
              />
            </div>
            <div className={S.formFooter}>
              <CustomButton
                title={STRINGS.CANCEL}
                onClick={resetForm}
                buttonClass={cx(S.formFooterButton, S.formFooterCancel)}
              />

              <CustomButton
                type="submit"
                title={STRINGS.SEND}
                onClick={handleSubmit}
                buttonClass={S.formFooterButton}
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const validate = (values) => {
  console.log(values);
  const errors = {};
  if (!values[STRINGS.EMAIL_BODY]) {
    errors[STRINGS.EMAIL_BODY] = WARNINGS.REQUIRED;
  }
  return errors;
};
